var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElementsIconSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#A2ABB5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.082 20.876l.794-.794c.166-.165.166-.432 0-.598l-4.267-4.268c-.081-.08-.187-.123-.3-.123h-.463c1.107-1.283 1.779-2.953 1.779-4.78 0-4.04-3.273-7.313-7.313-7.313C6.272 3 3 6.273 3 10.312c0 4.04 3.273 7.313 7.312 7.313 1.828 0 3.498-.672 4.781-1.78v.465c0 .112.046.218.123.299l4.268 4.267c.166.166.433.166.598 0zm-9.77-4.939c-3.108 0-5.625-2.517-5.625-5.625s2.517-5.625 5.625-5.625 5.625 2.517 5.625 5.625-2.517 5.625-5.625 5.625z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementsIconSearch);
export default __webpack_public_path__ + "static/media/elements-icon-search.48903d50a2344b06a6f40ffa5beea37f.svg";
export { ForwardRef as ReactComponent };